const emptyPic = 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=';

export default emptyPic;


// WEBPACK FOOTER //
// ./src/components/emptyPic.js